import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 12px;
    background-color: #ffffff;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
`;

export const IconWrapper = styled.div<{ $backgroundColor: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    flex-shrink: 0;
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
`;

export const Title = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #232323;
`;

export const Description = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    color: #6b6b6b;
`;
